/* eslint-disable camelcase */
import axios from "axios";
//Limitless
import ClientContext from "@limitless/common/utils/client-context/ClientContext";
import { log as logger } from "@limitless/common/utils/Logging";
import { createPublicAPIRequest } from "@limitless/common/utils/PublicAPIUtils";
import { handleAPIFailure } from "@limitless/common/utils/api-log-helper/APILogHelper";
import { MESSAGE_STATE_NEW, MESSAGE_STATE_CLOSED, MESSAGE_STATE_REPORTED } from "../../utils/customer-message-state-engine/CustomerMessageStateConstants";
import { uploadAttachment } from "@limitless/common/apis/attachments/AttachmentAPI";
import { CREATE, VERIFY } from "../../../portal/utils/ReContactMessageConstant";
/**
 * A customer has a question, let's submit it to the platform, via le intgration module
 *
 * @param {object} customer
 * @param {function} callback
 */
export const createCustomerMessage = (customer, callback) => {
  const log = logger.getLogger("CustomerMessageAPI createCustomerMessage");
  const {
    name,
    email,
    question,
    mobileNumber,
    tenantSubject,
    customerLastName,
    verificationCode,
    enforce
  } = customer;
  log.debug(`Creating message for ${name}, ${email}, ${question}`);
  const trimmedName = name.trim();
  const splitNameArr = trimmedName.split(" ");
  const message = {
    groupName: ClientContext._groupName,
    body: question.trim(),
    customerEmail: email,
    customerFirstName: splitNameArr[0],
    customerLastNameInitial: splitNameArr[1] ? splitNameArr[1] : "",
    tenantChannel: "llm",
    tenantMsgType: ClientContext._tenantMsgType,
    tenantMsgId: ClientContext._tenantMsgId,
    tenantProp1: ClientContext._msgProp1,
    tenantProp2: ClientContext._msgProp2,
    tenantProp3: ClientContext._msgProp3,
    tenantProp4: ClientContext._msgProp4,
    tenantProp5: ClientContext._msgProp5,
    tenantProp6: ClientContext._msgProp6,
    tenantProp7: ClientContext._msgProp7,
    tenantProp8: ClientContext._msgProp8,
    tenantProp9: ClientContext._msgProp9,
    tenantMsgSource: ClientContext._tenantMsgSource,
    clientAppVersion: process.env.REACT_APP_VERSION
  };
  if ((customer === null || customer === void 0 ? void 0 : customer.verificationCode) !== "") {
    message.verificationCode = verificationCode;
  }
  if (mobileNumber) {
    message.customerPhone = mobileNumber.replace(new RegExp(" ", "g"), "");
  }
  if (ClientContext._extraInfo) {
    message.customerData = ClientContext._extraInfo;
  }
  if (ClientContext._newMessageReContactRules === CREATE || ClientContext._newMessageReContactRules === VERIFY) {
    message.enforce = enforce;
  }
  if (tenantSubject) {
    message.tenantSubject = tenantSubject;
  }
  if (customerLastName) {
    message.customerLastName = customerLastName;
  }
  if (ClientContext._customerSecData) {
    message.customerSecData = ClientContext._customerSecData;
  }
  if (ClientContext._customerUtsc) {
    message.customerUtsc = ClientContext._customerUtsc;
  }
  if (ClientContext._userCaptureSuppress === "email" || ClientContext._userCaptureSuppress === "all") {
    Reflect.deleteProperty(message, "customerEmail");
  }
  if (ClientContext._userCaptureSuppress === "name" || ClientContext._userCaptureSuppress === "all") {
    Reflect.deleteProperty(message, "customerFirstName");
    Reflect.deleteProperty(message, "customerLastNameInitial");
  }
  const customerData = {};
  if (ClientContext._customerUtsc) {
    if (customer.customerKey) {
      customerData.customerKey = customer.customerKey || null;
    }
    if (customer.customerEmailHash) {
      customerData.customerEmailHash = customer.customerEmailHash || null;
    }
  }
  let additionalHeaders = null;
  if (ClientContext._customerUtsc) {
    additionalHeaders = {
      UTSC: ClientContext._customerUtsc
    };
  }
  const apiConfig = createPublicAPIRequest("post", "messages", customerData, message, additionalHeaders, true);

  //Ajax call URL, payload, config
  axios(apiConfig).then(response => {
    // Platform Give "REJ - Rejected" or "ACC - accepted" while creating the message
    if (response.data.processCode === "REJ") {
      callback({
        hasError: true,
        message: response.data.rejectReasonCode
      });
    } else {
      var _response$headers;
      //merge our message object with fields from API
      Object.assign(message, response.data);
      Object.assign(message, {
        messageId: message.msgId
      });
      Reflect.deleteProperty(message, "msgId");
      message.footerState = MESSAGE_STATE_NEW;
      message.customerKey = ((_response$headers = response.headers) === null || _response$headers === void 0 ? void 0 : _response$headers.customerkey) || null;
      callback(message);
    }
  }).catch(error => {
    handleAPIFailure(error, "CustomerMessageAPI createCustomerMessage");
    callback({
      hasError: true,
      message: error
    });
  });
};

/**
 * Calling the GET message API to retrieve a message with all dialogues
 *
 * @param {string} messageId
 * @param {function} callback
 */
export const fetchCustomerMessage = (messageId, accessKey, callback) => {
  const log = logger.getLogger("CustomerMessageAPI fetchCustomerMessage");
  let additionalHeaders = {
    "App-Name": process.env.REACT_APP_NAME.toLowerCase(),
    "App-Type": "web",
    "App-Version": process.env.REACT_APP_VERSION
  };
  if (ClientContext._customerUtsc) {
    additionalHeaders = {
      ...additionalHeaders,
      UTSC: ClientContext._customerUtsc
    };
  }
  const fetchRequestParams = {
    readonly: false,
    requester: "customer",
    access_key: accessKey
  };
  const apiConfig = createPublicAPIRequest("put", `messages/${messageId}/read`, fetchRequestParams, null, additionalHeaders);
  axios(apiConfig).then(response => {
    const message = response.data;
    log.info("Read completed %o", response);
    if (message) {
      //we never get this back from the read API
      message.accessKey = message.accessKey ? message.accessKey : accessKey;
      callback(message);
    } else {
      callback({
        hasError: true
      });
    }
  }).catch(error => {
    let isAccessDenied = false;
    try {
      var _error$response, _error$response$data;
      if (((_error$response = error.response) === null || _error$response === void 0 ? void 0 : (_error$response$data = _error$response.data) === null || _error$response$data === void 0 ? void 0 : _error$response$data.code) === "1527") {
        isAccessDenied = true;
      }
    } catch (err) {
      handleAPIFailure(err, "CustomerMessageAPI fetchCustomerMessage");
    }
    if (!isAccessDenied) {
      handleAPIFailure(error, "CustomerMessageAPI fetchCustomerMessage");
    }
    callback({
      hasError: true,
      isAccessDenied
    });
  });
};
const mutateCustomerMessage = (message, action, callback) => {
  const log = logger.getLogger("CustomerMessageAPI mutateCustomerMessage");
  const {
    mutationName,
    queryParams,
    data,
    headers,
    processResponse
  } = action;
  const {
    messageId
  } = message;
  const apiConfig = createPublicAPIRequest("put", `messages/${messageId}/${mutationName}`, {
    access_key: message.accessKey,
    ...queryParams
  }, data, headers);
  log.debug(apiConfig);
  axios(apiConfig).then(response => {
    let message;
    if (processResponse) {
      message = processResponse(response.data);
    } else {
      message = response.data;
    }
    callback(message);
  }).catch(error => {
    handleAPIFailure(error, `CustomerMessageAPI mutateCustomerMessage ${mutationName}`);
    callback({
      hasError: true
    });
  });
};
export const acceptExpertAnswer = (message, hasAccepted, callback) => {
  const ACCEPT_ACTION = {
    mutationName: "accept",
    data: {
      accepted: hasAccepted
    },
    processResponse: () => {
      const newMessage = {
        ...message
      };
      if (!hasAccepted) {
        newMessage.custConfirmation = false;
        newMessage.accepted = false;
        newMessage.acceptedDate = null;
      } else {
        newMessage.accepted = true;
        newMessage.acceptedDate = new Date().getTime();
      }
      return newMessage;
    }
  };
  mutateCustomerMessage(message, ACCEPT_ACTION, callback);
};
export const submitSuggestedAnswerFeedback = (message, selectedDialogueId, callback) => {
  const requestBody = {
    status: "rejected"
  };
  if (selectedDialogueId) {
    requestBody.status = "accepted";
    requestBody.dialogueId = selectedDialogueId;
  }
  const SA_FEEDBACK_ACTION = {
    mutationName: "feedback",
    data: requestBody
  };
  mutateCustomerMessage(message, SA_FEEDBACK_ACTION, callback);
};

/**
 * Submit the CSAT score back the Platform
 *
 * @param {object} message
 * @param {int} score
 * @param {function} callback
 */
export const submitMessageScore = (message, score, callback) => {
  const SCORE_ACTION = {
    mutationName: "vote",
    data: {
      score
    },
    processResponse: () => ({
      ...message,
      customerScore: score
    })
  };
  mutateCustomerMessage(message, SCORE_ACTION, callback);
};

/**
 * Review a client on a scale of 0-10 & submit feedback
 *
 * @param {object} message
 * @param {object} custClientReview -  {clientScore, feedback}
 * @param {function} cb
 */
export const submitNetPromotorScoreNFeedback = (message, custClientReview, cb) => {
  const NPS_ACTION = {
    mutationName: "clientfeedback",
    data: {
      ...custClientReview
    },
    processResponse: () => ({
      ...message,
      ...custClientReview
    })
  };
  mutateCustomerMessage(message, NPS_ACTION, cb);
};

/**
 * Submit the customer Testimonial back to the Platform
 *
 * @param {object} message
 * @param {string} testimonial
 * @param {function} callback
 */
export const submitMessageTestimonial = (message, testimonial, callback) => {
  const TESTIMONIAL_ACTION = {
    mutationName: "testimonial",
    data: {
      testimonial
    },
    processResponse: () => ({
      ...message,
      custTestimonial: testimonial
    })
  };
  mutateCustomerMessage(message, TESTIMONIAL_ACTION, callback);
};

/**
 * Users can add dialogues to the conversation
 *
 * @param {object} message
 * @param {object} customer
 * @param {string} response
 * @param {string} accessKey
 */
export const createDialogue = (message, customer, response, callback) => {
  const {
    name
  } = customer;
  const {
    accessKey,
    messageId
  } = message;
  const data = {
    body: response,
    customerName: name
  };
  const apiConfig = createPublicAPIRequest("post", `messages/${messageId}/reply`, {
    access_key: accessKey
  }, data);

  //Ajax call URL, payload, config
  axios(apiConfig).then(response => {
    callback(response.data);
  }).catch(error => {
    handleAPIFailure(error, "CustomerMessageAPI createDialogue");
    callback({
      hasError: true
    });
  });
};
export const addCustomerAttachment = (message, file, body = "", callback) => {
  const data = {
    fileName: file.name,
    fileSize: file.size,
    body: body !== null && body !== void 0 ? body : "",
    contentType: file.type
  };
  const apiConfig = createPublicAPIRequest("put", `messages/${message.messageId}/attach`, {
    access_key: message.accessKey
  }, data);
  axios(apiConfig).then(response => {
    const url = response.data.s3UploadUrl;
    uploadAttachment(url, file, result => {
      callback(result);
    });
  }).catch(error => {
    handleAPIFailure(error, "CustomerMessageAPI Attachement");
    callback({
      hasError: true,
      error: error.response.data
    });
  });
};
export const reportCustomerMessage = (message, callback) => {
  const REPORT_ACTION = {
    mutationName: "report",
    data: {
      callMethod: "REPORT"
    },
    processResponse: () => ({
      ...message,
      footerState: MESSAGE_STATE_REPORTED
    })
  };
  mutateCustomerMessage(message, REPORT_ACTION, callback);
};
export const escalateCustomerMessage = (message, callback) => {
  const ESCALATE_ACTION = {
    mutationName: "escalate",
    data: {
      callMethod: "ESCALATE"
    },
    processResponse: () => ({
      ...message,
      footerState: MESSAGE_STATE_CLOSED
    })
  };
  mutateCustomerMessage(message, ESCALATE_ACTION, callback);
};

/**
 * Customers can respond to requests for secure data
 *
 * @param {object} message
 * @param {object} body
 */

export const secureData = (message, body) => {
  return new Promise((resolve, reject) => {
    const {
      messageId
    } = message;
    const data = {
      ...body
    };
    const apiConfig = createPublicAPIRequest("put", `messages/${messageId}/secure_data`, {
      access_key: message.accessKey
    }, data, null, true);
    axios(apiConfig).then(() => resolve()).catch(error => {
      handleAPIFailure(error, "CustomerMessageAPI secureData");
      reject();
    });
  });
};
export const generateCustomerVerificationCode = (customer, groupName, callback) => {
  const {
    customerFirstName,
    email
  } = customer;
  const body = {
    customerFirstName,
    email,
    groupName: ClientContext._groupName
  };
  const data = {
    ...body
  };
  const apiConfig = createPublicAPIRequest("post", "customer/verification_code", {}, data);
  //Ajax call URL, payload, config
  axios(apiConfig).then(response => {
    callback(response.data);
  }).catch(error => {
    handleAPIFailure(error, "CustomerMessageAPI generateCustomerVerificationCode");
    callback({
      hasError: true,
      message: error
    });
  });
};